// services/pusher.js
import Pusher from "pusher-js";

// Configuration
const APP_KEY = "ff0c4bcf8aa2e02426b8";
const CLUSTER = "ap2";

// Simple object with methods
const pusherInstance = {
  pusher: null,
  channel: null,
  isConnected: false,

  initialize() {
    if (!this.pusher) {
      try {
        this.pusher = new Pusher(APP_KEY, {
          cluster: CLUSTER,
          encrypted: true,
        });

        this.pusher.connection.bind("connected", () => {
          this.isConnected = true;
        });

        this.pusher.connection.bind("disconnected", () => {
          this.isConnected = false;
        });

        // ✅ Add this to see all connection events
        this.pusher.connection.bind("state_change", (states) => {
          console.log("🔄 Pusher state change:", states);
        });

        return true;
      } catch (error) {
        console.error("Pusher init error:", error);
        return false;
      }
    }
    return true;
  },

  subscribeToChannel(channelName) {
    if (!this.pusher) {
      this.initialize();
    }

    if (this.channel) {
      try {
        this.pusher.unsubscribe(this.channel.name);
      } catch (e) {}
    }

    try {
      this.channel = this.pusher.subscribe(channelName);

      // ✅ Log all events received on this channel
      this.channel.bind_global((eventName, data) => {
        console.log(`📨 Global event received: ${eventName}`, data);
      });

      return this.channel;
    } catch (error) {
      console.error("Subscribe error:", error);
      return null;
    }
  },

  listenToEvent(eventName, callback) {
    if (!this.channel) {
      console.error("No channel!");
      return;
    }
    this.channel.bind(eventName, (data) => {
      callback(data);
    });
  },

  disconnect() {
    if (this.channel) {
      try {
        this.pusher.unsubscribe(this.channel.name);
      } catch (e) {}
      this.channel = null;
    }
    if (this.pusher) {
      try {
        this.pusher.disconnect();
      } catch (e) {}
      this.pusher = null;
      this.isConnected = false;
    }
  },

  // ✅ Add this to test sending a test event
  testEmit() {
    if (this.channel) {
      // This is just for testing - it won't actually send to others
      // but will help verify if the channel is working
    }
  },
};

export default pusherInstance;
